import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
export var StyleCenterGrid = withStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
})(Grid);
export var StyledGrid = withStyles({
    root: {
    // margin: "10px 0",
    },
    item: {
        margin: 0,
    },
})(Grid);
export var StyledTitleGridBorder = withStyles({
    item: {
        border: '1px solid #ddd',
        backgroundColor: 'rgb(245, 246, 251)',
        // fontWeight: "bold",
        color: 'rgb(7, 44, 130)',
        padding: '0.6em',
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minHeight: 'initial',
    },
})(Grid);
export var StyledTitleGridBorder2 = withStyles({
    item: {
        // fontSize: "0.875rem",
        border: '1px solid #ddd',
        backgroundColor: 'rgb(137, 134, 134)',
        // fontWeight: "bold",
        color: 'white',
        padding: '0.6em',
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minHeight: 'initial',
    },
})(Grid);
export var StyledGridBorder = withStyles({
    item: {
        border: '1px solid #ddd',
        padding: '0.6em',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        minHeight: 'initial',
        backgroundColor: 'white',
        '& > div': {
            width: '100%',
        },
    },
})(Grid);
export var StyledGridBorder2 = withStyles({
    item: {
        fontSize: '0.875rem',
        border: '1px solid #ddd',
        padding: '0.6em',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        minHeight: 'initial',
        backgroundColor: 'white',
        '& > div': {
            width: '100%',
        },
    },
})(Grid);
export var StyledGridBorderNoChild = withStyles({
    item: {
        border: '1px solid #ddd',
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        minHeight: 'initial',
        backgroundColor: 'white',
        '& > div': {
            width: '100%',
        },
    },
})(Grid);
export var GridProportion = {
    xs: {
        titlecols: 4,
        contentcols: 8,
        contentlongcols: 8,
    },
    sm: {
        titlecols: 2,
        contentcols: 4,
        contentlongcols: 10,
    },
};
